export interface ApiError {
  message: string
  status?: number
  code?: string
}

export const handleApiError = (error: any): ApiError => {
  if (error.response) {
    const { status, data } = error.response
    return {
      message: data?.errors?.[0]?.message || data?.message || data?.error || getErrorMessage(status),
      status,
      code: data?.code
    }
  } else if (error.request) {
    return {
      message: "Network error. Please check your connection and try again.",
      status: 0
    }
  } else {
    return {
      message: error.message || "An unexpected error occurred."
    }
  }
}

const getErrorMessage = (status: number): string => {
  switch (status) {
    case 400:
      return "Invalid request. Please check your input and try again."
    case 401:
      return "Authentication required. Please log in again."
    case 403:
      return "You don't have permission to perform this action."
    case 404:
      return "The requested resource was not found."
    case 409:
      return "A conflict occurred. The resource may already exist."
    case 422:
      return "Validation failed. Please check your input."
    case 429:
      return "Too many requests. Please try again later."
    case 500:
      return "Internal server error. Please try again later."
    case 502:
      return "Bad gateway. Please try again later."
    case 503:
      return "Service unavailable. Please try again later."
    default:
      return "An error occurred. Please try again."
  }
}

// These functions will be overridden by the ToastProvider
let showErrorToastImpl = (error: ApiError) => {
  console.error("API Error:", error.message)
}

let showSuccessToastImpl = (message: string) => {
  console.log("Success:", message)
}

export const showErrorToast = (error: ApiError) => {
  showErrorToastImpl(error)
}

export const showSuccessToast = (message: string) => {
  showSuccessToastImpl(message)
}

// Functions to set the actual toast implementations
export const setToastImplementations = (
  errorToast: (error: ApiError) => void,
  successToast: (message: string) => void
) => {
  showErrorToastImpl = errorToast
  showSuccessToastImpl = successToast
}
